module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.a709ab60.ttf";